import { render, staticRenderFns } from "./SystemGeneratedAlerts.vue?vue&type=template&id=75a1fd40&"
import script from "./SystemGeneratedAlerts.vue?vue&type=script&lang=js&"
export * from "./SystemGeneratedAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports